










































































































































import { Component, Vue } from 'vue-property-decorator'
import PageHeader from '@/components/PageHeaderComponent.vue'
import WebCheckInService from '@/api/hotel/WebCheckInService'
import AuthenticationService from '@/api/security/AuthenticationService'
import ValidationService from '@/api/security/ValidationService'
import LogService from '@/api/broadcast/LogService'
import store from '@/store/store'
import { VaerifyUser } from '@/shared/models/VaerifyUser'
import { WebCheckIn } from '@/shared/models/WebCheckIn'
import { CreateUser } from '@/shared/models/CreateUser'
import LatestPoliciesService from '@/api/policies/LatestPoliciesService'
import PopUpListComponent, { PopUpListOption } from '@/components/PopUpListComponent.vue'
import libphonenumber from 'google-libphonenumber'
import VGUserService from '@/api/vguser/VGUserService'
import UserManagementService from '@/api/user/UserManagementService'
import BookingService from '@/api/hotel/BookingService'
import downloadAppFunc from '@/shared/functions/downloadAppFunc'
import PopUpComponent from '@/components/popups/PopUpComponent.vue'
import userInfoFunc from '@/shared/functions/userInfoFunc'
import InputFieldComponent from '@/components/input/InputFieldComponent.vue'
import ButtonComponent from '@/components/buttons/ButtonComponent.vue'
import InputFieldPhoneNumberGroup from '@/components/input/InputFieldPhoneNumberGroup.vue'
import DividerComponent from '@/components/dividers/DividerComponent.vue'
import { Booking } from '@/api/hotel/models/Booking'

@Component({
  components: {
    PageHeader,
    PopUpListComponent,
    PopUpComponent,
    InputFieldComponent,
    ButtonComponent,
    InputFieldPhoneNumberGroup,
    DividerComponent
  }
})

export default class SignUpPage extends Vue {
  public isLoading = false;
  public webCheckIn: WebCheckIn = { Email: '', FirstName: '', LastName: '', HotelName: '', EntryType: '' }
  public userInfo: CreateUser = { FirstName: '', LastName: '', Email: '', Identifier: '', Password: '', PhoneNumber: '', Token: '', CreationType: '', TermsAndConditions: '', PrivacyPolicy: '', Id: '' }
  public pressedSignUpWithoutCheck = false
  private inputValidation = false
  public acceptedTerms = false
  public createAccountPressed = false
  public countryCode = ''
  public userPassword = ''
  public callingCodes: PopUpListOption[] = []
  public openCountryCode = false
  private restCountries: any = { }
  private validationResponse: any
  private vaerifyUser = new VaerifyUser()
  public isRoomService = false
  private webCheckInBooking: WebCheckIn = new WebCheckIn()
  private bookingInfo: Booking = new Booking()
  public existingUser = false
  public showErrorPopUp = false
  public isDesktop = false

  public async created () {
    if (this.$route.name === 'qr') {
      this.isRoomService = true
      this.$store.state.isRoomService = true
      LogService.LogInformation('Join, PreJoinPage, user has entered joinpage ' + this?.$route.params.chaincode + ': ' + this?.$route.params.sitecode, { UsersEntered: 1 }, `${this.$route.params.chaincode}:${this.$route.params.sitecode}`)
    }

    if (this.$route.params.identifier !== undefined && this.$route.params.token !== undefined) {
      store.saveIdentifier({ Identifier: this.$route.params.identifier, Token: this.$route.params.token })
      await this.GetInformationFromWebCheckIn()
      if (this.$route.params.lang !== undefined) {
        this.$i18n.locale = this.$route.params.lang
      }
    } else {
      this.userInfo.CreationType = 'Raw'
    }

    this.fillOutFields()

    if (this.$route.params.bookingId) {
      store.saveBookingId(this.$route.params.bookingId)
      await this.GetSpecificBooking()
      await this.CheckUserExists()
    }

    await this.GetAndSetPolicies()
    // await this.getRestCountries()
    this.extractCountryCode()

    // SoMe sign-up
    this.initAppleLogin()
    this.isDesktop = downloadAppFunc.checkIfDesktop()
  }

  // Decode identifier (phone) and prepopulate phone input fields if user comes from raw join.
  private async DecodeIdentifier () {
    try {
      if (!this.$route.params.identifier.includes('@')) {
        const decodedIdentifier = await WebCheckInService.DecodeToken(this.$route.params.identifier)
        this.parsePhoneNumber(decodedIdentifier)
      }
      LogService.LogInformation('Join, CreateAccountPage, Decoded token', { DecodedToken: 1 })
    } catch (error) {
      LogService.LogError('Join, CreateAccountPage, Decode token failed', { DecodeTokenFailed: 1 })
    }
  }

  private async GetInformationFromWebCheckIn () {
    try {
      const response = await AuthenticationService.CreateSession(this.$route.params.identifier, this.$route.params.token)
      store.saveToken(response.Sessions[0].Token)

      if (!this.$route.params.bookingId) {
        await this.DecodeIdentifier()
      }

      this.webCheckIn = await WebCheckInService.GetHotelInfo(this.$route.params.identifier, this.$route.params.token)
      store.saveHotelInfo(this.webCheckIn)

      if (this.$store.state.vaerifyUser.FirstName !== '') {
        this.userInfo.FirstName = this.webCheckIn.FirstName
        this.userInfo.LastName = this.webCheckIn.LastName
      } else {
        this.userInfo.FirstName = this.$store.state.vaerifyUser.FirstName
        this.userInfo.LastName = this.$store.state.vaerifyUser.LastName
      }
    } catch (error) {
      // do nothing
    }
  }

  private async GetSpecificBooking () {
    try {
      this.webCheckInBooking = await WebCheckInService.GetHotelInfoByBookingId(this.$route.params.bookingId)
      // this.bookingInfo = await BookingService.GetBookingInfo(this.$route.params.bookingId)
      this.parsePhoneNumber(this.webCheckInBooking.PhoneNumber!)
      if (this.webCheckInBooking.Status === 'PreCheckedin' || this.webCheckInBooking.Status === 'Checkedin') {
        if (!this.$store.state.chekcInSuccessToastShown) {
          this.$store.dispatch('toastSuccess', { title: this.$t('common.success') + ' ' + this.$t('download.checkedIn') + '!🎉', timeout: 1000000 })
          this.$store.state.chekcInSuccessToastShown = true
        }
      }
    } catch (error) {
      LogService.LogInformation(`Failed to get booking for bookingId: ${this.$route.params.bookingId} with error: ${JSON.stringify(error)} (Join)`, {})
    }
  }

  private parsePhoneNumber (fullNumber: string) {
    try {
      const phoneUtil = libphonenumber.PhoneNumberUtil.getInstance()
      const phone = phoneUtil.parseAndKeepRawInput(fullNumber)
      this.countryCode = '+' + phone.getCountryCode()
      this.userInfo.PhoneNumber = '' + phone.getNationalNumber()
    } catch (error) {
      LogService.LogInformation(`Failed to parse phone number: ${fullNumber} with error: ${error} (Join)`, {})
    }
  }

  private async CheckUserExists () {
    try {
      // this.bookingInfo = await BookingService.GetBookingInfo(this.$route.params.bookingId)
      this.existingUser = await UserManagementService.GetUserExistsByPhoneNumber(this.bookingInfo.Guests?.[0].PhoneNumber!)
    } catch (error) {
      LogService.LogInformation(`Failed to get user for bookingId: ${this.$route.params.bookingId} with error: ${JSON.stringify(error)} (Join)`, {})
    }
  }

  private async GetAndSetPolicies () {
    try {
      const ToSResponse = await LatestPoliciesService.GetTermsAndConditions()
      const PPResponse = await LatestPoliciesService.GetPrivacyPolicy()

      this.userInfo.TermsAndConditions = ToSResponse.Version
      this.userInfo.PrivacyPolicy = PPResponse.Version
      LogService.LogInformation('Join, CreateAccountPage, ToS and PP fetched', { ToSAndPPFetched: 1 })
    } catch (error) {
      LogService.LogError('Join, CreateAccountPage, TOS and PP fetch failed', { ToSAndPPFetchFailed: 1 })
      this.HandleException()
    }
  }

  private extractCountryCode () {
    try {
      if (this.webCheckIn !== null) {
        const phoneUtil = libphonenumber.PhoneNumberUtil.getInstance()
        if (this.webCheckIn.PhoneNumber !== null) {
          const phone = phoneUtil.parseAndKeepRawInput(this.webCheckIn.PhoneNumber!)
          this.countryCode = '+' + phone.getCountryCode()
          this.userInfo.PhoneNumber = '' + phone.getNationalNumber()
        }
      }
    } catch (error) {
      LogService.LogError('Join, CreateAccountPage, ExtractCountryCode failed', { CountryCodeExtractionFailed: 1 })
    }
  }

  // Validate input form by checking that everything is filled out
  // returns false if something is missing
  private inputFormValidate () {
    if (this.validate(this.userInfo.FirstName) ||
        this.validate(this.userInfo.LastName) ||
        this.validate(this.userInfo.PhoneNumber) ||
        this.validate(this.userPassword)
    ) {
      return false
    } else {
      return true
    }
  }

  // returns true if there's an error
  public validate (inputParam: any) {
    if (this.inputValidation) {
      return userInfoFunc.validateInput(inputParam)
    }
    return false
  }

  // ToS and PP.
  public TermsClicked () {
    this.pressedSignUpWithoutCheck = false
  }

  public async onSubmit () {
    this.inputValidation = true
    this.createAccountPressed = true
    const temp = this.countryCode + this.userInfo.PhoneNumber

    try {
      this.validationResponse = await ValidationService.ValidatePhoneNumber(temp)
    } catch (error) {
      this.createAccountPressed = false
    }

    this.userInfo.PhoneNumber = this.validationResponse?.E164Number.replace(this.countryCode, '')
    if (!this.acceptedTerms) {
      this.pressedSignUpWithoutCheck = true
      LogService.LogInformation('ToS and PP checkbox not checked', { CreateUserTermsNotChecked: 1 })
      return
    }
    if (this.inputFormValidate()) {
      // const str = this.countryCode
      if (!this.countryCode.includes('+')) {
        this.countryCode = '+' + this.countryCode
      }
      // For use on next view
      store.savePhoneNumber(this.validationResponse.E164Number.replace(this.countryCode, ''))
      store.saveCountryCode(this.countryCode)

      this.isLoading = true
      try {
        store.saveUserInfo(this.userInfo)
        this.$store.state.vaerifyUser = await VGUserService.V2CreateVaerifyUser(this.countryCode + this.userInfo.PhoneNumber)
        this.$store.state.vaerifyUser.Password = this.userPassword
        this.$store.state.vaerifyUser.FirstName = this.userInfo.FirstName
        this.$store.state.vaerifyUser.LastName = this.userInfo.LastName
        this.$store.state.vaerifyUser.CreationType = this.webCheckIn?.EntryType ?? 'Raw'
        this.$store.state.vaerifyUser.UserId = this.webCheckIn?.UserId ?? null

        this.$store.state.vaerifyUser.HotelId = this.webCheckInBooking?.HotelId ?? null
        this.$store.state.vaerifyUser.PMSBookingNumber = this.webCheckInBooking?.PMSBookingNumber ?? null
        this.$store.state.vaerifyUser.ReservationNumber = this.webCheckInBooking?.ReservationNumber ?? null
        this.$router.push({ name: 'confirm-confirmation-code' })
      } catch (error) {
        this.HandleException()
        LogService.LogError(`Creation of Vaerify user failed for ${this.userInfo.PhoneNumber}`, {})
      }
      this.isLoading = false
    }
  }

  private async HandleException () {
    this.showErrorPopUp = true
    this.isLoading = false
  }

  public closeErrorPopUp () {
    this.showErrorPopUp = false
  }

  private fillOutFields () {
    const user = store.getUserInfo()
    if (user) {
      this.userInfo.FirstName = user.FirstName || ''
      this.userInfo.LastName = user.LastName || ''
      this.userInfo.PhoneNumber = store.getPhoneNumber() || ''
      this.countryCode = store.getCountryCode() || ''
    }
  }

  public continueSoMe (soMe: string) {
    this.$router.push({ name: 'enter-phone', params: { soMeType: soMe } })
  }

  private initAppleLogin () {
    const appleScript = document.createElement('script')
    appleScript.setAttribute('src', 'https://appleid.cdn-apple.com/appleauth/static/jsapi/appleid/1/en_US/appleid.auth.js')
    document.body.appendChild(appleScript)
  }

  public async appleLogin () {
    try {
      // eslint-disable-next-line no-undef
      AppleID.auth.init({
        clientId: 'com.aeroguest.join',
        scope: 'name email',
        redirectURI: 'https://staging.join.aeroguest.com/enterphone/apple',
        state: 'createUser',
        nonce: this.$route.params.identifier || '123456',
        usePopup: true
      })

      // eslint-disable-next-line no-undef
      const data = await AppleID.auth.signIn()
      const decoded = this.decodeJWT(data.authorization.id_token)

      if (this.checkValidDate(decoded.exp)) {
        this.$store.state.appleUser.FirstName = data.user?.name.firstName
        this.$store.state.appleUser.LastName = data.user?.name.lastName
        this.$store.state.appleUser.Id = decoded.sub
        this.$store.state.appleUser.Email = data.user?.email
        this.continueSoMe('apple')
      } else {
        this.showErrorPopUp = true
      }
    } catch (error) {
      LogService.LogError(`Failed to sign in with Apple with error ${JSON.stringify(error)}`, {})
    }
  }

  private decodeJWT (token: string) {
    return JSON.parse(Buffer.from(token.split('.')[1], 'base64').toString())
  }

  private checkValidDate (exp: number) {
    // exp is epoch seconds, date.now() is in ms
    if (exp > Math.floor(Date.now() / 1000)) {
      return true
    } else {
      return false
    }
  }

  public async downloadApp () {
    await downloadAppFunc.checkOS()
  }

  public goToTermsOfService () {
    LogService.LogInformation('Join pages - clicked on go to Terms of Service', {})
    window.open('https://faq.aeroguest.com/terms-of-service', '_blank')
  }

  public goToPrivacyPolicy () {
    LogService.LogInformation('Join pages - clicked on go to Privacy Policy', {})
    window.open('https://faq.aeroguest.com/privacy-policy', '_blank')
  }
}
